import { lazy } from "react";

const TakeOrder = lazy(() => import("./pages/take-order"));

export const basePath = "/app/dashboard/order-management/"

export const OrderTakingPaths = {
    takeOrder: basePath + "take-order",
}

export const OrderTakingBreadcrumbs = {
    takeOrder: {
        href: OrderTakingPaths.takeOrder,
        label: "Take Order"
    }
}

const OrderTakingRoutes = [
    {
        path: OrderTakingPaths.takeOrder,
        component: TakeOrder
    }
]
export default OrderTakingRoutes